<template>
	<el-row type="flex" :justify="((data.campaign_node === '已审批' && !data.result) || data.bmcstatus !== '1') ? 'space-between' : 'end'">
		<div v-if="(getUserLoginType !== 'HCM' || data.bmcstatus === '1') && data.campaign_node === '待审批'">
			<span v-for="(item, index) in approvalBtn" :key="index">
				<el-popover
					trigger="manual"
					placement="bottom"
					v-model="item.visible"
					width="300">
					<div>
						<div v-if="data.campaignmodel == 1 && getUserLoginType !== 'HCM' && item.result == 1">
							<div style="margin-bottom: 16px;font-weight: 600;">
								下级审批人
							</div>
							<div>
								<el-select v-model="subordinateUserid" multiple placeholder="请选择" size="mini" style="width: 300px;" @change="savaCampaignTags(subordinateUserid)">
							    <el-option
							      v-for="item in dataOptions"
							      :key="item.value"
							      :label="item.title"
							      :value="item.value">
							    </el-option>
							  </el-select>
							</div>
							<div style="margin-bottom: 8px;color: rgba(0, 0, 0, 0.247);font-size: 12px;">
								如需下一级审批，请选择审批人。未选择则至本级审批完结。
							</div>
							<div style="float: left;" v-for="item in buttonArr" v-if="buttonArr && buttonArr[0].tags">
								<el-button type="success" plain size="mini" style="margin-bottom: 16px;margin-right: 8px;" @click="buttonClick(item)" :disabled="item.disabled">{{item.tags}}</el-button>
							</div>
						</div>

						<div style="margin-bottom: 16px;font-weight: 600;clear: both;">
							审批说明
						</div>
						<el-input
							v-model="item.bindText"
							:maxlength="200"
							type="textarea"
							show-word-limit
							placeholder="在此输入审批意见(可不填)">
						</el-input>
						<el-row type="flex" justify="end" style="margin-top: 10px">
							<el-button size="mini" type="plain" @click="onPassOrBackActivity(item)" :loading="newLoading">{{ item.text }}</el-button>
							<el-button size="mini" type="plain" @click="onChangeVisible(item, index)">取消</el-button>
						</el-row>
					</div>
					<el-button
						style="margin-right: 10px"
						slot="reference"
						:icon="item.result === 1 ? 'el-icon-circle-check' : 'el-icon-refresh-left'"
						size="mini"
						@click="onChangeVisible(item, index)"
						:type="item.result === 1 ? 'success' : 'warning'">{{ item.text }}
					</el-button>
				</el-popover>
			</span>
			<el-popover
				v-if="getUserLoginType !== 'HCM'"
				v-model="transVisible"
				placement="bottom"
				trigger="manual">
				<div>
					<el-input
						size="small"
						placeholder="输入关键字进行过滤"
						v-model="filterText">
					</el-input>
					<el-tree
						class="filter-tree"
						:data="personData"
						node-key="value"
						:props="defaultProps"
						@node-click="handleNodeClick"
						:filter-node-method="filterNode"
						ref="tree">
					</el-tree>
					<div>
						已选:  {{ selectItem.title }}
					</div>
					<div>
						<el-input
							v-model="transText"
							:maxlength="200"
							type="textarea"
							show-word-limit
							placeholder="在此输入审批意见(可不填)">
						</el-input>
					</div>
					<el-row type="flex" justify="end" style="margin-top: 10px">
						<el-button size="mini" type="plain" @click="onPassOrBackActivity('trans')">转交</el-button>
						<el-button size="mini" type="plain" @click="transVisible = false">取消</el-button>
					</el-row>
				</div>
				<el-button
					icon="el-icon-refresh-right"
					slot="reference"
					size="mini"
					type="primary"
					@click="transVisible = !transVisible">
					转交
				</el-button>
			</el-popover>
		</div>
		<div v-if="data.result">
			<ActivityLogState :state="data.result"/>
		</div>
		<span @click="onOpenLog(data)" class="log-text">
			日志
		</span>
		<!-- 日志抽屉 -->
		<ActivityLog
			:visible="logVisible"
			@on-close="logVisible = false"
			:data="logData"
			:motherData="logMotherData"
		/>
	</el-row>
</template>

<script>
import _ from 'lodash';
// import ActivityMixin from '@/mixins/activityMixin.js';
import LogMixin from '@/mixins/logMixin';
import ActivityLogState from './activityLogState';
import ActivityLog from './activityLog';
import { mapGetters, mapActions, mapState } from 'vuex';
export default {
	name: 'activityApprovalOperate',

	components:{
		ActivityLog,
		ActivityLogState
	},

	mixins: [
		LogMixin,
		// ActivityMixin
	],

	watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    }
  },

	props: {
		data: {
			type: Object
		}
	},

	data () {
		return {
			buttonArr: [],
			subordinateUserid: [],
			dataOptions: [],
			newLoading: true,
			logVisible: false,
			personData: [],
			filterText: '',
			defaultProps: {
				children: 'children',
				label: 'title'
			},
			transText: '',
			transVisible: false,
			approvalBtn: [
				{ text: '通过', result: 1, visible: false, bindText: '' },
				{ text: '驳回', result: 2, visible: false, bindText: '' }
			],
			exuserid: 0,
			selectItem: {
				title: ''
			},
			tagId: '',
		}
	},

	methods: {
		handleNodeClick(data, node) {
			if(!data.children) {
				this.selectItem = data;
			}
		},
    filterNode(value, data) {
      if (!value) return true;
      return data.title.indexOf(value) !== -1;
		},
		...mapActions([
			'reqActivityApproval',
			'reqActivityDetail'
		]),
		onChangeVisible(item, index) {
			item.visible = !item.visible;
			this.approvalBtn[index ? 0 : 1].visible = false;
			console.log(123)
			this.newLoading = false
			this.getUserTreeByCampaignId(this.data.hid)
		},
		onPassOrBackActivity(item) {
			const params = {
				approverUserid: this.selectItem.value, //转交人id
				examineView: item === 'trans' ? this.transText : item.bindText, //审核意见
				campaignId: this.getActivityDetail.details.id, //活动id
				examineResult: item === 'trans' ? 3 : item.result, //审核结果
				camProId: this.data.hid, //活动产品id
				dealerId: this.getActivityDetail.details.dealer_id, //经销商编号
				time: this.$options.filters.fullTime(this.getActivityDetail.details.updatetime),
			};
			if (this.subordinateUserid && this.subordinateUserid.length != 0) {
				params.subordinateUserid = this.subordinateUserid.join(',')
			}
			if (this.logintype === "HCM") {
				params.campaignUserId = this.exuserid;
			}
			if(item === 'trans' && !this.selectItem.value) {
				this.$message.error('请选择转交人');
				return;
			}
			for (const i in params) {
				if (!params[i]) {
					delete params[i];
				}
			}
			console.log(params);
			this.newLoading = true
			this.reqActivityApproval(params).then(res => {
				if (res.status === "10000") {
					this.$message.success("提交成功");
					// 关闭所有弹窗
					this.transVisible = false;
					this.approvalBtn[0].visible = false;
					this.approvalBtn[1].visible = false;
					this.load();
				}
				if (res.status === "400") {
					this.$message.error(res.message);
				}
			});
		},
		// 重新加载详情页数据
		load() {
			this.reqActivityDetail({
				id: this.$route.params.id
			}).then(() => {
				// this.echoTableData(this.activityDetail.campaignProductList, this.activityDetail.details.campaignway, true);
			})
		},
		// 保存标签
		savaCampaignTags(item) {
			let tagsArr = []
			for (let a in item) {
				for (let b in this.dataOptions) {
					if (item[a] == this.dataOptions[b].value) {
						tagsArr.push(this.dataOptions[b].title)
					}
				}
			}
			let data = {
				userid: item.join(','),
				tags: tagsArr.join(','),
			}
			if (this.tagId) {
				data.id = this.tagId
			}
			fetch({
				url: "hcm/campgign/savaCampaignTags",
				method: "post",
				data: JSON.stringify(data),
				headers: {
					'Content-Type': 'application/json',
				},
				noFormat: false,
				responseType: "json"
			}).then((res) => {
				if(res.status === '10000') {
					this.getCampaignTagsdetils()
				} else {
					this.$message.error(res.message);
				}
			}).catch(err => {
				this.$message.error('服务器出错');
			})
		},
		// 获取下级审批人
		getUserTreeByCampaignId(hid) {
			let params = {
				cproIds: hid
			}
			fetch({
        url: "hcm/userout/getUserTreeByCampaignId",
        method: "get",
        noFormat: true,
				params: params,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let {data}=res
        if(res.status == '10000'){
					this.dataOptions = []
					for (let a in data) {
						for (let b in data[a].children) {
							this.dataOptions.push(data[a].children[b])
						}
					}
					this.getCampaignTagsdetils()
        } else {
          this.$message({
            message: res.message,
            type: "error"
          });
        }
      }).catch(err => {
				this.$message.error('服务器出错');
			})
		},
		buttonClick(item) {
			for (let b in this.buttonArr) {
				if (this.buttonArr[b].userid == item.userid) {
					this.subordinateUserid.push(Number(item.userid))
					this.buttonArr[b].disabled = true
				}
			}
		},
		// 标签回显
		getCampaignTagsdetils() {
			fetch({
        url: "hcm/campgign/getCampaignTagsdetils",
        method: "get",
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let {data}=res
        if(res.status == '10000'){
					this.buttonArr = []
					if (data) {
						this.tagId = data.id
						let dataTagsArr = data.tags.split(',')
						let dataUserid = data.userid.split(',')
						let newData = []
						let newArr = []
						for (let a in dataUserid) {
							newData.push({
								tags: dataTagsArr[a],
								userid: dataUserid[a],
								disabled: false
							})
						}
						for (let t in this.dataOptions) {
							newArr.push(Number(this.dataOptions[t].value))
						}
						for (let c in newData) {
							if (newArr.indexOf(Number(newData[c].userid)) == -1) {
								newData[c].disabled = true
							}
						}
						this.buttonArr = newData
						for (let b in this.buttonArr) {
							for (let e in this.subordinateUserid) {
								if (this.buttonArr[b].userid == this.subordinateUserid[e]) {
									this.buttonArr[b].disabled = true
								}
							}
						}
					}
        } else {
          this.$message({
            message: res.message,
            type: "error"
          });
        }
      }).catch(err => {
				this.$message.error('服务器出错');
			})
		},
		// 过滤在流程中的人----转交数据
		filterTransPersonData() {
			if(this.data.subuserids) {
				const data = _.cloneDeep(this.getActivityPerson);
				const excludePersionIdArr = this.data.subuserids.split(',');
				const res = [];
				function loop(data, lastNodeData) {
					if(data.children) {
						lastNodeData.children = [];
						loop(data.children, lastNodeData)
					}else {
						if(Array.isArray(data)) {
							data.forEach((item, index) => {
								if(item.children) {
									lastNodeData[index] = _.cloneDeep(item);
									loop(item, lastNodeData[index]);
								}else {
									loop(item, lastNodeData.children);
								}
							})
						}else {
							if(data.type === 'dept') {
								return;
							}
							if(!excludePersionIdArr.includes(String(data.value))) {
								lastNodeData.push(data)
							}
						}
					}
				}

				loop(data, res)
				this.personData = res;

			}
		}
	},

	computed: {
		...mapGetters([
			"getActivityDetail",
			"getUserLoginType",
			'getActivityPerson',
		]),
		// ...mapState({
		// 	activityDetail: state => state.activityApproval.activityDetail
		// }),
	},

	mounted(){
		this.filterTransPersonData();

	}
}
</script>

<style lang="scss">
.log-text {
	color: #409EFF;
	cursor: pointer;
}
</style>
